<template>
  <Modal
    v-model="visible"
    class-name="view-form"
    :title="$t('rules.copyRule')"
    :width="650"
    :mask-closable="false"
    @on-visible-change="closeModal"
  >
    <Form ref="formRef" :model="formData" :rules="rules">
      <FormItem label="Rule ID" prop="id">
        <i-input v-model="formData.id" size="large" />
      </FormItem>
      <FormItem :label="$t('common.name')">
        <i-input v-model="formData.name" size="large" />
      </FormItem>
    </Form>

    <div slot="footer">
      <Button type="text" @click="closeModal">{{ $t('common.cancel') }}</Button>
      <Button type="primary" :loading="isLoading" @click="submit">{{ $t('common.submit') }}</Button>
    </div>
  </Modal>
</template>

<script>
import nodeID from '@/mixins/nodeID'
import { viewRule, createRule } from '@/api/rules'
import { removeObjectEmptyValue } from '@/utils/handleData'

export default {
  name: 'CopyRuleModal',

  props: {
    modalVisible: { type: Boolean, default: false },
    ruleID: { type: String, default: '' },
  },

  mixins: [nodeID],

  data() {
    return {
      formData: {
        name: '',
      },
      isLoading: false,
      rules: {
        id: [{ required: true, message: this.$t('rules.idRequired') }],
      },
      copyRuleData: {},
    }
  },

  computed: {
    visible: {
      get() {
        return this.modalVisible
      },
      set(val) {
        this.$emit('update:modalVisible', val)
      },
    },
  },

  watch: {
    ruleID: {
      immediate: true,
      handler(newV) {
        if (newV) {
          this.getRuleDetail(newV)
        }
      },
    },
  },

  methods: {
    getRuleDetail(ruleID) {
      viewRule(this.nodeID, ruleID).then((res) => {
        const { data } = res
        const { name } = data
        this.formData.name = name || ''
        this.copyRuleData = data
      })
    },

    async copyRule() {
      try {
        const { triggered, id: copyRuleId, name: copyRuleName, ...restRuleData } = this.copyRuleData
        const submitData = {
          ...restRuleData,
          ...this.formData,
          triggered: false, // default shutdown rule
        }
        const bodyData = removeObjectEmptyValue(submitData)
        const res = await createRule(this.nodeID, bodyData)
        const { status, statusText, data } = res
        if (status === 201 && statusText === 'Created') {
          this.$Message.success(data)
        } else {
          this.$Message.success(this.$t('common.copySuccess'))
        }
        return Promise.resolve(res)
      } catch (error) {
        return Promise.resolve(error)
      }
    },

    closeModal(val) {
      if (typeof val === 'boolean') {
        this.visible = val
      } else {
        this.visible = false
      }
      if (!this.visible) {
        this.$refs.formRef.resetFields()
        this.formData = {
          name: '',
        }
      }
    },

    async submit() {
      try {
        this.isLoading = true
        const validFormRes = await this.$refs.formRef.validate()
        if (validFormRes) {
          const res = await this.copyRule()
          const { status } = res
          if (status) {
            this.visible = false
            this.$emit('submited')
          }
        }
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
